<script lang="ts">
  import Object from "./Object.svelte";
</script>

<Object {...$$props}
  ><path
    d="M32,12a3,3,0,1,0-3-3A3,3,0,0,0,32,12Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,32,8Z"
  /><path
    d="M26,12a3,3,0,1,0,3,3A3,3,0,0,0,26,12Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,26,16Z"
  /><path
    d="M38,22a7,7,0,0,0,.938-13.938,7,7,0,0,0-13.876,0A7,7,0,0,0,26,22a6.924,6.924,0,0,0,2-.3V62h8V58h5V52H36V50h5V44H36V21.7A6.924,6.924,0,0,0,38,22ZM21,15a5.006,5.006,0,0,1,5-5h1V9A5,5,0,0,1,37,9v1h1a5,5,0,1,1-5,5H31a5,5,0,0,1-10,0ZM39,46v2H34v6h5v2H34v4H30V56h2V54H30V52h2V50H30V48h2V46H30V20.727A7.04,7.04,0,0,0,32,18.6a7.04,7.04,0,0,0,2,2.124V46Z"
  /><path
    d="M38,18a3,3,0,1,0-3-3A3,3,0,0,0,38,18Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,38,14Z"
  /></Object
>
